export default __webpack_public_path__ + "static/media/headerBackground.5a4fffd3.png";